module.exports = __webpack_public_path__ + "static/businessPlan-9ef829ce6aea6cb9e12da0ab1a9255de.png";